import { Button, Checkbox, Col, Form, Input, Modal, Row, Select } from "antd";
import { bwtsData, BwtsOptions } from "../../../../../Data/data";
import { useEffect, useState } from "react";

const { Option } = Select;

const AddBWTSModal = ({ responseData, visible, onOk, onCancel, errors }) => {
  const [form] = Form.useForm();
  const [machineryDropdown, setMachineryDropdown] = useState("");
  const [selectedParams, setSelectedParams] = useState([]);
  const [customParams, setCustomParams] = useState([]);

  useEffect(() => {
    if (responseData) {
      form.setFieldsValue({
        BWT_name: responseData?.BWT_name || "",
        BWT_maker: responseData?.BWT_maker || "",
        BWT_model: responseData?.BWT_model || "",
      });
      setMachineryDropdown(responseData?.machinery_type || "");
      setSelectedParams(responseData?.selected_parameters || []);
      setCustomParams(
        Array.isArray(responseData?.other_parameters) ? responseData?.other_parameters : []
      );
    } else {
      form.resetFields();
      setMachineryDropdown("");
      setSelectedParams([]);
      setCustomParams([]);
    }
  }, [responseData, form, visible]);

  useEffect(() => {
    if (errors && Object.keys(errors).length > 0) {
      const fieldErrors = Object.keys(errors).map((key) => ({
        name: key,
        errors: [errors[key]],
      }));
      form.setFields(fieldErrors);
    }
  }, [errors, form]);

  // Update parameters list when machineryDropdown changes
  useEffect(() => {
    const selectedData = bwtsData.find(
      (item) => item?.label?.toUpperCase() === machineryDropdown?.toUpperCase()
    );
    setSelectedParams(selectedData?.parameters || []);
  }, [machineryDropdown]);

  const handleAddParam = () => {
    setCustomParams([...customParams, { name: "" }]);
  };

  const handleCustomChange = (index, value) => {
    const updated = [...customParams];
    updated[index].name = value;
    setCustomParams(updated);
  };

  const handleDeleteParam = (index) => {
    setCustomParams(customParams.filter((_, i) => i !== index));
  };

  const handleCheckbox = (item) => {
    setSelectedParams((prev) =>
      prev.includes(item) ? prev.filter((param) => param !== item) : [...prev, item]
    );
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then((values) => {
        const data = {
          machinery_dropdown: machineryDropdown,
          selectedParams,
          customParams,
          ...values,
        };
        onOk(data);
        form.resetFields();
        setMachineryDropdown("");
        setSelectedParams([]);
        setCustomParams([]);
      })
      .catch((errorInfo) => {
        console.log("Validation Failed:", errorInfo);
      });
  };

  const renderParameters = (parameters) => (
    <Row gutter={16}>
      <Col span={12}>
        {parameters.slice(0, Math.ceil(parameters.length / 2)).map((item, index) => (
          <div key={index}>
            <Checkbox checked={selectedParams.includes(item)} onChange={() => handleCheckbox(item)}>
              {item}
            </Checkbox>
          </div>
        ))}
      </Col>
      <Col span={12}>
        {parameters.slice(Math.ceil(parameters.length / 2)).map((item, index) => (
          <div key={index}>
            <Checkbox checked={selectedParams.includes(item)} onChange={() => handleCheckbox(item)}>
              {item}
            </Checkbox>
          </div>
        ))}
      </Col>
    </Row>
  );

  const renderCustomParameters = () => (
    <div style={{ marginTop: 16 }}>
      <b>Add Other Parameters</b>
      {customParams.map((param, index) => (
        <Row gutter={8} key={index} style={{ marginTop: 8 }}>
          <Col span={10}>
            <Input
              placeholder="Parameter"
              value={param.name}
              maxLength={50}
              onChange={(e) => handleCustomChange(index, e.target.value)}
            />
          </Col>
          <Col span={10}>
            <Input
              placeholder="Unit"
              value={param.unit}
              maxLength={10}
              onChange={(e) => handleCustomChange(index, "unit", e.target.value)}
            />
          </Col>
          <Col span={4}>
            <Button danger onClick={() => handleDeleteParam(index)} block>
              ×
            </Button>
          </Col>
        </Row>
      ))}
      <Button type="dashed" onClick={handleAddParam} style={{ marginTop: 12 }}>
        + Add Parameter
      </Button>
    </div>
  );

  return (
    <Modal title="Add BWTS" open={visible} onOk={handleSubmit} onCancel={onCancel} destroyOnClose>
      <Form
        form={form}
        layout="vertical"
        onValuesChange={(changedValues) => {
          Object.keys(changedValues).forEach((key) => {
            form.setFields([{ name: key, errors: [] }]);
          });
        }}
      >
        <Row gutter={[16, 16]}>
          <Col span={24}>
            <label>Select BWTS Type</label>
            <Select
              style={{ width: "100%" }}
              value={machineryDropdown}
              onChange={setMachineryDropdown}
              placeholder="Select BWTS Type"
            >
              {BwtsOptions.map((item) => (
                <Option key={item} value={item}>
                  {item}
                </Option>
              ))}
            </Select>
          </Col>

          <Col span={24}>
            <Form.Item
              label="BWTS Name"
              name="BWT_name"
              rules={[{ required: true, message: "Please enter BWTS Name" }]}
            >
              <Input placeholder="BWTS Name" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="BWTS Make"
              name="BWT_maker"
              rules={[{ required: true, message: "Please enter BWTS Make" }]}
            >
              <Input placeholder="BWTS Make" maxLength={50} />
            </Form.Item>
          </Col>

          <Col span={24}>
            <Form.Item
              label="BWTS Model"
              name="BWT_model"
              rules={[{ required: true, message: "Please enter BWTS Model" }]}
            >
              <Input placeholder="BWTS Model" maxLength={50} />
            </Form.Item>
          </Col>

          {machineryDropdown && machineryDropdown !== "OTHER" && (
            <Col span={24}>
              {renderParameters(
                bwtsData.find(
                  (item) => item.label.toUpperCase() === machineryDropdown.toUpperCase()
                )?.parameters || []
              )}
              {renderCustomParameters()}
            </Col>
          )}
          {machineryDropdown === "OTHER" && <Col span={24}>{renderCustomParameters()}</Col>}
        </Row>
      </Form>
    </Modal>
  );
};

export default AddBWTSModal;
